export const environment = {
    siteId: 1,
    name: 'babylon',
    apiBaseUrl: 'https://cansimoneta-api-dev.clicktotravel.es/api',
    baseUrl: 'https://cansimoneta-dev.clicktotravel.es',
    token: '',
    email: 'front@clicktotravel.es',
    password: 'B5k}DE32?CK5',
    userPanel: 'admin',
    passPanel: '1234',
    booking_engine_enabled: false, // General switch for booking engine
    booking_engine_top_enabled: true, // Switch for booking engine button in top sliders
    booking_engine_extern: true,
    booking_button_engine_enabled: false, // Button booking engine
    openInNewWindow: false,
    trailingSlash: true,
    multipleMotorsModal: false,
    normalizeUrlsToLowercase: false,
    minSizeMobileHeader: 768,
    menuComplexLinks: true,
    booking_engine_widget: false, // Use widget booking engine
    booking_engine_widget_dynamic: false, // widget static down
    dataBase: '../data/',
    sitesIndexFile: 'sites.json',
    fallbackUrl: 'https://babylon-dev.clicktotravel.es/',
};
